import { render, staticRenderFns } from "./MultipleChoiceTextQuestionTextImageAnswer.vue?vue&type=template&id=095ab354"
import script from "./MultipleChoiceTextQuestionTextImageAnswer.vue?vue&type=script&lang=js"
export * from "./MultipleChoiceTextQuestionTextImageAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports